/**
 * @file use-route-loading.js
 * @description Hook para mostrar loading automaticamente durante mudanças de rota (CRA)
 */

import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import { useLoading } from "../components/feedback/loading/hooks/use-loading.js"

/**
 * Hook para mostrar loading automaticamente durante mudanças de rota
 * @returns {void}
 */
export function useRouteLoading() {
  const { showLoading, hideLoading } = useLoading()
  const location = useLocation()
  const pathname = location.pathname
  const previousPathnameRef = useRef(null)
  const loadingTimeoutRef = useRef(null)

  useEffect(() => {
    // Se é a primeira renderização, não mostrar loading
    if (previousPathnameRef.current === null) {
      previousPathnameRef.current = pathname
      return
    }

    // Se a rota mudou, mostrar loading
    if (previousPathnameRef.current !== pathname) {
      showLoading("Carregando página...")
      
      // Limpar timeout anterior se existir
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current)
      }
      
      // Auto-hide loading após um tempo mínimo
      loadingTimeoutRef.current = setTimeout(() => {
        hideLoading()
      }, 300)
      
      // Atualizar referência
      previousPathnameRef.current = pathname
    }
  }, [pathname, showLoading, hideLoading])

  // Limpar timeout quando o componente desmonta
  useEffect(() => {
    return () => {
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current)
      }
    }
  }, [])
}
